<template>
    <QuickSelectionModal
        :title="filter.title"
        cypress-handle="quick-filters-modal"
        :model-value="selectedOptions"
        :options="options"
        :multiple="filter.multiple"
        @update:model-value="updateFilters"
    />
</template>
<script setup>
    import {
        isArray, get,
    } from 'lodash'
    import { useFilterStore } from '@/stores/filter'
    import { useFilters } from '@/composables'
    import QuickSelectionModal from '@/components/ui/QuickSelectionModal.vue'

    const props = defineProps({
        filterUuid: String,
        filter: Object,
        groupIds: {
            type: Array,
            default: () => [],
        },
    })

    const filterStore = useFilterStore()
    const { withoutNestedFilter, withNestedFilter } = useFilters()

    const activeFilters = computed(() => {
        return filterStore.filtersForUuid(props.filterUuid)
    })

    const selectedOptions = computed(() => {
        const value = get(activeFilters.value, [...props.groupIds, props.filter.id]) ?? []

        // Always work with an array internally as it's easier to handle
        return isArray(value)
            ? value
            : [value]
    })

    const options = computed(() => {
        return props.filter.options ?? []
    })

    const updateFilters = (val) => {
        if (!val.length) {
            filterStore.updateFilters(
                props.filterUuid,
                withoutNestedFilter(activeFilters.value, props.filter.id, props.groupIds),
            )
            return
        }

        filterStore.updateFilters(
            props.filterUuid,
            withNestedFilter(
                props.filter.multiple ? val : val[0],
                activeFilters.value,
                props.filter.id,
                props.groupIds,
            ),
        )
    }
</script>
